import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Drawer,
  SquareBorderButton,
  HoverAccentButton,
  AccentButton,
  Text
} from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';
import { ParticipantType } from 'components/LiveClass/utils/consts';
import UserMedia from '../../components/UserMedia';

import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class MembersDrawer extends Component {
  renderInviteLearners = () => {
    const { model } = this.props;
    const { participantType } = model.store;
    const { copyURL } = model.store.joinLiveClass;

    if (participantType !== ParticipantType.Teacher) {
      return null;
    }

    return (
      <div className={s.inviteLearnersContainer}>
        <div>Invite Learners</div>
        <SquareBorderButton
          text="Copy Link"
          onClick={copyURL}
          icon={{ type: 'contentCopy' }}
          className={s.copyButton}
        />
      </div>
    );
  };

  renderLearnerMedia = (media) => {
    const { isMobile } = this.props.model.store;
    return (
      <UserMedia
        key={media.userId}
        mediaStore={media}
        className={s.userMedia(isMobile)}
        isMobile={isMobile}
      />
    );
  };

  renderLearners = () => {
    const { model } = this.props;

    const { learnerMedias } = model.store.participants;

    if (learnerMedias.length < 1) {
      return null;
    }

    return (
      <div className={s.learnersSection}>
        <Text.HeaderCaps className={s.sectionLabel}>Learners</Text.HeaderCaps>
        {learnerMedias.map(this.renderLearnerMedia)}
      </div>
    );
  };

  renderTeacher = () => {
    const { model } = this.props;
    const { isMobile } = model.store;
    const { teacherMedia } = model.store.participants;

    if (!teacherMedia) {
      return null;
    }

    return (
      <div className={s.teacherSection}>
        <Text.HeaderCaps className={s.sectionLabel}>Teacher</Text.HeaderCaps>
        <UserMedia
          mediaStore={teacherMedia}
          className={s.userMedia(isMobile)}
          isMobile={isMobile}
        />
      </div>
    );
  };

  renderHeader = () => {
    const { model, theme } = this.props;
    const { membersDrawer, activity } = model.store;
    const { hideDrawer } = membersDrawer;
    const { showPopup } = activity;

    return (
      <div className={s.header(theme)}>
        <HoverAccentButton
          icon={{ type: 'arrow-left' }}
          text="Members"
          className={s.membersButton(theme)}
          onClick={hideDrawer}
        />
        <AccentButton text="Activity" onClick={showPopup} />
      </div>
    );
  };

  render() {
    const { model } = this.props;
    const { membersDrawer, isMobile } = model.store;
    const { isDrawerVisible } = membersDrawer;

    return (
      <Drawer visible={isDrawerVisible} className={s.drawer(isMobile)} hideCloseButton={true}>
        {this.renderHeader()}
        <div className={s.membersContainer}>
          {this.renderTeacher()}
          {this.renderLearners()}
        </div>
        {this.renderInviteLearners()}
      </Drawer>
    );
  }
}

export default MembersDrawer;
